"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalStorageKeys = exports.RequestHeaders = exports.ResponseFields = void 0;
exports.ResponseFields = {
    AccessToken: 'accessToken',
    AccessTokenExpiry: 'expiresIn',
    RefreshToken: 'refreshToken',
    FieldIdSamlToken: 'fieldIdSamlToken',
    EcomplianceSamlToken: 'eComplianceSamlToken',
};
exports.RequestHeaders = {
    AccessToken: 'x-access-token',
    RefreshToken: 'x-refresh-token',
    ReCAPTCHAToken: 'x-recaptcha-token',
    ApiKey: 'x-api-key',
};
exports.LocalStorageKeys = exports.ResponseFields;
